<script setup>
/* eslint-disable */

import { onMounted, ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useInitializeStore } from '@/stores/initialize';
import { useLiveSportOverview } from '@/stores/live_sport_overview';
import { useFixtureStore } from '@/stores/fixture';
import { useLiveSportsStore } from '@/stores/live_sports';
import { EditBetSlip } from '@/stores/edit_betslip';
import { useLiveCourtStore } from '@/stores/live_court';
import { useBestlineVideoStore } from '@/stores/bestline_video';
import { useVirtualCourtStore } from '@/stores/virtual_court';
import MyEditBetsSlips from '@/views/Bets/MyEditBetsSlips.vue';
import Footer from '@/components/Common/Footer.vue';
import Header from '@/components/Common/header.vue';
import MobileMenu from '@/components/Common/mobileMenu.vue';
import MyBetsSlips from './Bets/MyBetsSlips.vue';
import MarketingSection from '@/components/marketing/MarketingSection.vue';
import { useMarketingSection } from '@/composables/useMarketingSection';
import LiveIcon from '@/components/Common/LiveIcon.vue';
import LiveSportSlider from '@/components/live_sports/LiveSportsSlider.vue';
import { usePlatformConfigurationStore } from '@/stores/platform_configuration';

const fixtureStore = useFixtureStore();
const liveSportsStore = useLiveSportsStore();
const editBetslipStore = EditBetSlip();
const router = useRouter();
const initializeStore = useInitializeStore();
const liveSportOverviewStore = useLiveSportOverview();
const liveCourtStore = useLiveCourtStore();
const virtualCourtStore = useVirtualCourtStore();
const bestlineVideoStore = useBestlineVideoStore();
const mobile_active_tab = ref('virtual_court');

// Virtual Live is dropped up to 1280px, where the court sits in the fixture book,
// so the placement is not counted as having it there.
const marketing_excluded_types = computed(() => {
	if (initializeStore.screenWidth <= 1280) return ['virtual_live'];

	return [];
});
const { show_column: has_marketing_sidebar } = useMarketingSection('live-sport-sidebar', {
	exclude_types: marketing_excluded_types,
});


const goToOverview = () => {
	router.push( {name: 'live-sports-overview' });
}

const goToEventView = () => {
	liveSportOverviewStore.getFirstFixture
	router.push({ name: 'live-sports-eventview', params: { fixture_id: liveSportOverviewStore.getFirstFixture.id }});
}

const goToCompetition = (fixture) => {
	if (usePlatformConfigurationStore().isNewPreSportsLayoutEnabled) {
		router.push({name: 'live-sports-overview'});
		return;
	}

	router.push({ name: 'pre-sports-competition', params: { sport_id: fixture.sport_id, region_id: Number(fixture.region_id), competition_id: fixture.competition_id } } )
}
</script>


<template>
	<div class="main_div">
		<Header></Header>
		<!-- fixed mobile bottom menu-->
		<div class="fixed-btm-main">
			<div class="container-full fix-padding">
				<MobileMenu></MobileMenu>
			</div>
		</div>

			<div class="sports-main">
				<div class="container-full">
					<div class="sports-main-outer live_Sports-main-outer" :class="{ 'marketing-sidebar-hidden': router.currentRoute.value.name == 'live-sports-overview' && !has_marketing_sidebar, 'eventview-top-sec': router.currentRoute.value.name == 'live-sports-eventview' }">
						<div class="sports-outer-left">

							<!-- left sidebar  -->
							<div class="sports-left-sidebar">
								<div class="tab desktop-tab-left">
									<button class="tablinks" :class="{'active': router.currentRoute.value.name == 'live-sports-overview'}" @click="goToOverview">{{$t('general.overview')}}</button>
									<button class="tablinks" :class="{'active': router.currentRoute.value.name == 'live-sports-eventview'}" @click="goToEventView">{{$t('general.eventview')}}</button>
								</div>
							</div>
							<!-- left sidebar end -->

							<!-- center grid start -->
							<div class="sports-center-content">
								<div class="highlight-tab-mobile live-sports-mobile-tab">
									<div class="tab">
										<button class="tablinks" :class="{'active': router.currentRoute.value.name == 'live-sports-overview'}" @click="goToOverview">{{$t('general.overview')}}</button>
										<button class="tablinks" :class="{'active': router.currentRoute.value.name == 'live-sports-eventview'}" @click="goToEventView">{{$t('general.eventview')}}</button>
									</div>
								</div>

								<div v-if="router.currentRoute.value.name == 'live-sports-eventview'" class="competetion-back-btn">
									<a @click="router.back()" class="">
										<svg xmlns="http://www.w3.org/2000/svg" width="4.414" height="7.414" viewBox="0 0 4.414 7.414">
											<g id="Group_232" data-name="Group 232" transform="translate(0.707 0.525)">
												<line id="Line_7" data-name="Line 7" x1="3" y2="3" transform="translate(0 0.182)" fill="none"
													stroke="var(--white)" stroke-linecap="round" stroke-width="1"></line>
												<line id="Line_8" data-name="Line 8" x1="3" y1="3" transform="translate(0 3.182)" fill="none"
													stroke="var(--white)" stroke-linecap="round" stroke-width="1">
												</line>
											</g>
										</svg>&nbsp; {{ $t('general.back') }}
									</a>
								</div>
								<!-- game filter slider start-->
								<div class="league-silder game-filter-slider">
									<div class="">
										<div id="game-top_Slider" class="league-slider-main game-slider_main loaded">
											<LiveSportSlider/>
										</div>

									</div>
								</div>
								<!-- game filter slider end-->

							</div>
							<div v-if="router.currentRoute.value.name == 'live-sports-eventview' && fixtureStore.fixture != null">
								<div class="live-sports-tabs">
									<div class="live-sport-title">
										<div class="game-icon">
											<svg class="normal-img"
												xmlns="http://www.w3.org/2000/svg"
												xml:space="preserve"
												version="1.1"
												style="width:23px; fill: none; stroke: var(--white); shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
												viewBox="0 0 30 25"
												xmlns:xlink="http://www.w3.org/1999/xlink">
												<use :xlink:href="liveSportsStore.liveSportWhiteIcon(fixtureStore.fixtureBook.sport_id) + '#svg3108'" stroke-width="1px"  />
											</svg>
											<!-- <img :src="liveSportsStore.liveSportWhiteIcon(fixtureStore.fixtureBook.sport_id)" alt=""> -->
											<img class="region-icon" :src="'/assets' + fixtureStore.fixtureBook.region_icon_url" alt="">
										</div>
										<h6 @click="goToCompetition(fixtureStore.fixtureBook)">{{ fixtureStore.fixtureBook.region_name + ' - ' + fixtureStore.fixtureBook.competition_name }}</h6>
									</div>

									<div v-if="liveSportsStore.hasVirtualLive(fixtureStore.fixtureBook.sport_id) || liveCourtStore.hasVideo" class="eventview-virtual-tabs">
										<div v-if="liveCourtStore.hasVideo" class="virtual-tab-inner field-icon-container" @click="liveCourtStore.setActiveCourt('video')" :class="{'video-icon-selected ': liveCourtStore.active_court == 'video'}">
											<LiveIcon/>
										</div>

										<div v-if="liveSportsStore.hasVirtualLive(fixtureStore.fixtureBook.sport_id)" class="virtual-tab-inner" :class="{'active': liveCourtStore.active_court == 'vl'}" @click="liveCourtStore.setActiveCourt('vl')">
												<svg class="event-field-svg" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
												style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
												viewBox="0 0 50 34" xmlns:xlink="http://www.w3.org/1999/xlink" :style="{ height: fixtureStore.fixtureBook.sport_id === 22 ? '27px' : '' }">
												<use :xlink:href="liveSportsStore.virtualLiveIcon(fixtureStore.fixtureBook.sport_id) + '#Layer_x0020_1'" />
											</svg>
											<!-- <svg xmlns="http://www.w3.org/2000/svg" width="19" height="13.988" viewBox="0 0 19 13.988">
												<g id="Group_934" data-name="Group 934" transform="translate(-20.047 -558.794)">
												<g id="Group_933" data-name="Group 933" transform="translate(20.547 559.294)">
													<path id="path2506" d="M566.221-442h-2.9v-5.833h2.9Z" transform="translate(-548.221 451.406)" fill="none" stroke="var(--white)" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"/>
													<path id="path2508" d="M16.237-442h-2.9v-5.833h2.9Z" transform="translate(-13.333 451.406)" fill="none" stroke="var(--white)" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"/>
													<path id="path2510" d="M31.333-565.013h-18V-578h18Z" transform="translate(-13.333 578.001)" fill="none" stroke="var(--white)" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"/>
													<g id="g2512" transform="translate(6.226 3.719)">
													<path id="path2514" d="M-197.06-98.531a2.774,2.774,0,0,1-2.774,2.774,2.774,2.774,0,0,1-2.774-2.774,2.774,2.774,0,0,1,2.774-2.774A2.774,2.774,0,0,1-197.06-98.531Z" transform="translate(202.609 101.305)" fill="none" stroke="var(--white)" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"/>
													</g>
													<g id="g2516" transform="translate(9 0.083)">
													<path id="path2518" d="M0,0V12.822" fill="none" stroke="var(--white)" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"/>
													</g>
												</g>
												</g>
											</svg> -->
										</div>

										<div class="virtual-tab-inner" :class="{'active': liveCourtStore.active_court == 'scoreboard'}" @click="liveCourtStore.setActiveCourt('scoreboard')">
											<svg xmlns="http://www.w3.org/2000/svg" width="17.945" height="18" viewBox="0 0 17.945 18">
												<g id="Group_1734" data-name="Group 1734" transform="translate(-281.203 -149.412)">
												<g id="Group_1733" data-name="Group 1733" transform="translate(281.703 149.412)">
													<path id="path3134" d="M100-301.333h4.044v2.545H100Z" transform="translate(-97.987 311.459)" fill="none" stroke="var(--white)" stroke-miterlimit="10" stroke-width="1"/>
													<path id="path3144" d="M100-120.666h3.091v2.593H100Z" transform="translate(-97.939 135.558)" fill="none" stroke="var(--white)" stroke-miterlimit="10" stroke-width="1"/>
													<path id="path3146" d="M100-662.665h14.884v2.593H100Z" transform="translate(-97.939 663.18)" fill="none" stroke="var(--white)" stroke-miterlimit="10" stroke-width="1"/>
													<g id="g3148" transform="translate(0 0)">
													<path id="path3150" d="M0-664.665v-18" transform="translate(0 682.665)" fill="none" stroke="var(--white)" stroke-miterlimit="10" stroke-width="1"/>
													</g>
													<path id="path3152" d="M100-482h10.178v2.545H100Z" transform="translate(-97.987 487.328)" fill="none" stroke="var(--white)" stroke-miterlimit="10" stroke-width="1"/>
												</g>
												</g>
											</svg>
										</div>

									</div>

								</div>
							</div>
							<div v-if="router.currentRoute.value.name == 'live-sports-overview'" class="live-sports-center">
								<router-view></router-view>
							</div>
						</div>
						<!-- Marketing placement. The column disappears when nothing is configured. -->
						<div v-if="router.currentRoute.value.name == 'live-sports-overview' && has_marketing_sidebar" class="sports-outer-right overview-right-outer">
							<MarketingSection
								slug="live-sport-sidebar"
								:exclude_types="marketing_excluded_types"
								wrapper_class="marketing-live-sidebar"
							/>
						</div>
					</div>
					<template v-if="router.currentRoute.value.name == 'live-sports-eventview'">
						<router-view></router-view>
					</template>
				</div>
			</div>

		<!-- footer start -->
		<MyEditBetsSlips v-if="initializeStore.isSportsbookEnabled && editBetslipStore.edit_mode_enabled" />
		<MyBetsSlips v-if="initializeStore.isSportsbookEnabled && !editBetslipStore.edit_mode_enabled"/>
		<Footer></Footer>
		<!-- footer end -->
	</div>
</template>
<style scoped>
/*
 * The page grid reserves a fixed track for the sidebar. When the marketing
 * placement has nothing to render the column is removed from the DOM, so the
 * track has to go with it or the content keeps a dead strip beside it.
 */
.sports-main-outer.marketing-sidebar-hidden {
	grid-template-columns: 1fr;
}
/* The markup this replaced sat inside a padded wrapper; without it the cards ran
   flush into the edge of the viewport. Padding the placement rather than the
   column avoids fighting the nested rule that sets the column padding. */
.overview-right-outer :deep(.marketing-section) {
	box-sizing: border-box;
	padding: 0 16px;
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	.sports-main .eventview-top-sec .live-sports-tabs {
		display: flex;
		padding: 5px 17px 5px;
		align-content: center;
		align-items: center;
		justify-content: space-between;
	}
}

.main_div{
	background-color: var(--dark-gray);
}

@media screen and (min-width: 768px) and (max-width: 1281px) {
	.sports-main .live_Sports-main-outer {
		grid-template-columns: 1fr;
	}
}

/* @media screen and (min-width: 1279px) and (max-width: 1600px) {
	.sports-main .live_Sports-main-outer {
		grid-template-columns: 1fr 400px;
	}
} */

@media screen and (min-width: 320px) and (max-width: 991px) {
	.sports-main .eventview-top-sec .game-filter-slider {
		display:none;
	}

	.sports-main .live_Sports-main-outer .sports-center-content {
		display: block;
	}

	.sports-main .live_Sports-main-outer .sports-outer-left {
		grid-template-columns: 1fr;
	}

}

.sports-promotion-outer {
	max-width: 98vw !important;
}

@media screen and (min-width: 1026px) and (max-width: 1277px) {
	.sports-promotion-outer {
		margin-top: 0px !important;
		padding: 0 !important;
		border: 0 !important;
	}
}

html[dir="rtl"] .sports-main .eventview-top-sec .sports-outer-left .sports-left-sidebar .tab {
	margin-right: 20px;
}

html[dir="rtl"] .sports-left-sidebar .tab {
	margin-right: 20px;
}

html[dir="rtl"] .fix-padding {
	padding-left: unset;
	padding-right: unset;
}

.competetion-back-btn {
	display: none;
	margin-bottom: 5px;
}

.competetion-back-btn a {
	color: var(--white);
	text-decoration: none;
	font-size: 12px;
	font-weight: 300;
}

.competetion-back-btn a svg {
	width: 4px;
	height: 8px;
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	.competetion-back-btn {
		display: flex;
		padding-top: 3px;
	}

}

.region-icon {
	width: 21px !important;
	height: auto;
	margin-left: 5px;
}

html[dir="rtl"] .region-icon {
	margin-left: unset;
	margin-right: 5px;
}

.button-container {
    display: flex;
    justify-content: center;
    align-items: center;
	gap: 5px;
	margin-top: 20px;
}

.play-fill {
	fill: gray !important;
}

.play-fill-white {
	fill: var(--white);
}

.border {
	fill: none;
	stroke: gray;
	stroke-width: 1;
}

.border-white {
	fill: none;
	stroke: var(--white);
	stroke-width: 1;
}

.video-icon {
	width: 25px;
	height: 17px;
	cursor: pointer;
}

.field-icon-container:hover .play-fill {
	fill: var(--white);
}

.field-icon-container:hover .border {
	stroke: var(--white);
}

.video-icon-selected .play-fill {
	fill: var(--white);
}

.video-icon-selected .border {
	stroke: var(--white);
}

.event-field-svg {
	height: 17px;
	fill: var(--border-light) ;
	cursor: pointer;
}

.icon-selected .event-field-svg {
	fill: var(--white);
}

.event-field-svg:hover {
	fill: var(--white);
}
</style>